import {Injectable} from '@angular/core';

import {InvoiceSummaryViewModel} from './invoice-summary-view.model';
import {InvoiceDTO} from '@dto/invoices/invoices-dto.model';
import {FormattedNumber} from '@components/ui/table-template/classes/formatted-number';
import {Utils} from '@shared/utilities/utils';
import {IconViewModel} from '@components/ui/table-template/models/icon-view-model';
import {IconSize} from '@components/ui/table-template/enums/icon-size.enum';
import {APP_INVOICE_DETAILS} from '../../../config/app-urls';
import {IconColour} from '@components/ui/table-template/enums/icon-colour.enum';

@Injectable({
  providedIn: 'root'
})
export class InvoiceSummaryConverterService {

  public convert(clients: InvoiceDTO[]): InvoiceSummaryViewModel[] {
    return clients.map(c => this.convertSingle(c));
  }

  private convertSingle(invoice: InvoiceDTO): InvoiceSummaryViewModel {

    if (!(invoice.CustomerNo)) {
      invoice.CustomerNo = '';
    }

    if (!(invoice.CustomerName)) {
      invoice.CustomerName = '(Empty)';
    }

    if (!(invoice.CurrencyCode)) {
      invoice.CurrencyCode = '';
    }

    if (!(invoice.InvoiceCount)) {
      invoice.InvoiceCount = '0';
    }

    if (!(invoice.TotalNetBillAmount)) {
      invoice.TotalNetBillAmount = '0.00';
    }

    if (!(invoice.TotalRemainingAmount)) {
      invoice.TotalRemainingAmount = '0.00';
    }

    const customerName = invoice.CustomerName.trim();

    const iconImageUrl = Utils.getInvoiceStatusIconSource(invoice.Status);

    let iconIndex;
    switch (invoice.Status) {
      case 'Outstanding':
        iconIndex = 0;
        break;
      case 'Paid':
        iconIndex = 1;
        break;
      default:
        iconIndex = 2;
    }

    let invoiceCountStatement;
    if (invoice.InvoiceCount === '1') {
      invoiceCountStatement = '1 INVOICE';
    } else {
      invoiceCountStatement = invoice.InvoiceCount + ' INVOICES';
    }

    const detailsRouterLinkCommands = APP_INVOICE_DETAILS.toRouterLinkCommands(invoice.CustomerNo, invoice.CurrencyCode);

    return {
      clientNo: invoice.CustomerNo,
      customerName: customerName,
      currency: invoice.CurrencyCode,
      detailsRouterLinkCommands: detailsRouterLinkCommands,
      detailsLabel: customerName + ' - ' + invoiceCountStatement + ' - ' + invoice.CurrencyCode,
      invoiceCount: Number.parseInt(invoice.InvoiceCount, 10),
      invoiceCountStatement: invoiceCountStatement,
      totalNetBillAmount: new FormattedNumber(invoice.TotalNetBillAmount),
      totalRemainingAmount: new FormattedNumber(invoice.TotalRemainingAmount),
      statusIcon: new IconViewModel(iconImageUrl, invoice.Status, iconIndex, IconSize.Small, IconColour.Default)
    };
  }
}
